import { cn } from '../../../lib/utils';
import { Category, getCategoryColorClasses } from './categoryColors';

interface CategoryChipProps {
    category: Category;
    className?: string;
}

export const CategoryChip = ({ category, className }: CategoryChipProps) => {
    const colors = getCategoryColorClasses(category.color);
    return (
        <span
            className={cn(
                'inline-flex min-w-0 max-w-full items-center gap-1.5 rounded-full border border-zinc-600 bg-card px-2 py-0.5 text-xs font-medium',
                colors.chipText,
                className
            )}
        >
            <span
                aria-hidden="true"
                className={cn(
                    'h-1.5 w-1.5 shrink-0 rounded-full',
                    colors.swatch
                )}
            />
            <span className="truncate text-[11px]">{category.name}</span>
        </span>
    );
};
